@if(loading$ | async ){
  <div class="fixed inset-0 flex items-center justify-center backdrop-blur-xs z-[10]">
    <!-- <div class="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div> -->
    <img
    src="assets/images/loader-button.gif"
    alt=""
    class=""
  />
  </div>
}
